export type Role = "ADMIN" | "BOARD_MEMBER" | "RESIDENT" | "PUBLIC";

/** How each role is called on screen; what is stored stays the technical value. */
export const ROLE_LABEL: Record<Role, { es: string; en: string }> = {
  ADMIN: { es: "Administración", en: "Administration" },
  BOARD_MEMBER: { es: "Junta", en: "Board" },
  RESIDENT: { es: "Titular", en: "Owner" },
  PUBLIC: { es: "Público", en: "Public" },
};

export function roleLabel(role: string, lang: string): string {
  const label = ROLE_LABEL[role as Role];
  if (!label) return role;
  return lang.startsWith("en") ? label.en : label.es;
}
